import Vue from 'vue'

export const RefreshEvents = new Vue()
